/* eslint-disable no-nested-ternary */
import CloseFullscreenRoundedIcon from "@mui/icons-material/CloseFullscreenRounded";
import { Box, IconButton, Modal, Stack } from "@mui/material";
import React from "react";

import { CanvasAnnotation } from "types/imageAnnotations";

import { ImageCanvas } from "./common/ImageCanvas";

interface ImageLightBoxProps {
  imageSource: string;
  isOpen: boolean;
  onClose: Function;
  annotations?: CanvasAnnotation[];
  /** The ID of the image query, used for generating the download filename */
  iqId?: string;
}

export function ImageLightBox(props: ImageLightBoxProps) {
  const { isOpen, imageSource, onClose, annotations = [], iqId } = props;

  return (
    <Modal open={isOpen} onClose={() => onClose()}>
      <Box
        sx={{
          alignItems: "center",
        }}
        style={{ display: "flex" }}
        onClick={() => onClose()}
      >
        <Stack style={{ flex: "1", flexShrink: "0" }}>
          <Stack direction="row" justifyContent="flex-end">
            <IconButton
              edge="start"
              onClick={() => onClose()}
              aria-label="close"
              sx={{ color: "white" }}
              data-testid="close-button"
            >
              <CloseFullscreenRoundedIcon fontSize="large" />
            </IconButton>
          </Stack>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              objectFit: "contain",
              alignSelf: "center",
              width: "80%",
              height: "90vh",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <ImageCanvas imageUrl={imageSource} annotations={annotations} iqId={iqId} />
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
}
